import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { processAppEventProperty } from './process-app-event-property';

export const processAppEvent = z
  .object({
    name: z
      .string()
      .nullable()
      .optional()
      .describe('The event class name, which is the message name'),

    displayName: z
      .string()
      .nullable()
      .optional()
      .describe('Human-readable label'),

    description: z.string().nullable().optional().describe('Description'),

    processAppEventProperties: z
      .array(processAppEventProperty)
      .nullable()
      .optional()
      .describe("The event's declared fields"),
  })
  .describe(
    "An app event class a process can bind as a message: the message a receive task, message boundary event or message start listens for, or a send task sends. Its properties type `message` and the message's mappings.",
  )
  .as('ProcessAppEvent', { embedded: true });

export { processAppEvent as processAppEventSchema };
